import { render } from "./EditComment.vue?vue&type=template&id=3ca945bb"
import script from "./EditComment.vue?vue&type=script&lang=js"
export * from "./EditComment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__